import styled from 'styled-components/macro'

const ResultUrlContainer = styled.input`
  border: 2px solid #003399;
  border-radius: 4px;
  padding: 4px;
  font-size: 12px;
  width: 285px;
  margin-bottom: 8px;
`

export default ResultUrlContainer
